import React, { useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { businessInfo } from '../data/mock';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_tilefix-scheduler/artifacts/c05hbcds_IMG_1809.png";

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const navLinks = [
    { name: 'Services', href: '#services' },
    { name: 'About', href: '#about' },
    { name: 'Testimonials', href: '#testimonials' },
    { name: 'Contact', href: '#contact' }
  ];

  const scrollToSection = (e, href) => {
    if (!isHomePage) return; // Let Link handle navigation
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#0d1f33]/95 backdrop-blur-sm border-b border-[#F7931E]/20">
      <div className="container">
        <nav className="flex items-center justify-between h-24">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src={LOGO_URL} 
              alt="Top Notch Tile LLC" 
              className="h-20 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              isHomePage ? (
                <a
                  key={link.name}
                  href={link.href}
                  onClick={(e) => scrollToSection(e, link.href)}
                  className="text-white hover:text-[#F7931E] transition-colors duration-300 font-medium"
                >
                  {link.name}
                </a>
              ) : (
                <Link
                  key={link.name}
                  to={`/${link.href}`}
                  className="text-white hover:text-[#F7931E] transition-colors duration-300 font-medium"
                >
                  {link.name}
                </Link>
              )
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden md:flex items-center gap-4">
            <a href={`tel:${businessInfo.phone.replace(/\D/g, '')}`} className="flex items-center gap-2 text-[#8fa3b8] hover:text-white transition-colors">
              <Phone size={18} />
              <span className="font-medium">{businessInfo.phone}</span>
            </a>
            <Link 
              to="/estimate"
              className="btn-primary text-sm"
            >
              Get Free Estimate
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </nav>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-[#F7931E]/20">
            {navLinks.map((link) => (
              isHomePage ? (
                <a
                  key={link.name}
                  href={link.href}
                  onClick={(e) => scrollToSection(e, link.href)}
                  className="block py-3 text-white hover:text-[#F7931E] transition-colors font-medium"
                >
                  {link.name}
                </a>
              ) : (
                <Link
                  key={link.name}
                  to={`/${link.href}`}
                  className="block py-3 text-white hover:text-[#F7931E] transition-colors font-medium"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {link.name}
                </Link>
              )
            ))}
            <Link 
              to="/estimate"
              className="btn-primary w-full mt-4 text-sm"
              onClick={() => setMobileMenuOpen(false)}
            >
              Get Free Estimate
            </Link>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
